<template>
    <span v-if="translation !== false">
        <input :class="customClasses" :value="translatedValue || currentValue" @input="updateModel" :disabled="translatedValue !== null" v-bind="$attrs">
        <translate :translate-text="currentValue" @translatedText="(translated: string) => translatedValue = translated" />
    </span>
    <input v-else :class="customClasses" :value="currentValue" @input="updateModel" v-bind="$attrs">
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Emit, Prop, Watch } from '@/helpers/Decorators';

@Options({
    name: 'ideo-form-input',
    inheritAttrs: false
})
export default class IdeoFormInput extends Vue
{
    public currentValue: string = null;

    public translatedValue: string = null;

    @Prop({ default: false }) public translation: boolean;

    @Prop()
    public value: string;

    @Prop()
    public modelValue: string;

    @Prop({
        default: 'md',
        validator: (value: string) => ['sm', 'md', 'lg'].includes(value)
    })
    public size: string;

    public get customClasses(): Record<string, boolean>
    {
        return {
            'form-control': true,
            'form-control-sm': this.size == 'sm',
            'form-control-lg': this.size == 'lg'
        };
    }

    public focus(): void
    {
        this.$el.focus();
    }

    @Emit('input')
    @Emit('update:modelValue')
    public updateModel(e: Event): string
    {
        const target = e.target as HTMLInputElement;

        this.currentValue = target.value.trim();

        return this.currentValue;
    }

    @Watch('value', { immediate: true })
    @Watch('modelValue', { immediate: true })
    public onModelChanged(value: any[] | any): void
    {
        if (value !== undefined)
        {
            this.currentValue = value;
        }
    }
}
</script>
<style scoped>
span{
    display: contents;
}
</style>
